// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awards-top-section__nominate-btn-wrapper[data-v-55de08c6]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.awards-top-section__nominate-btn-wrapper .awards-top-section__nominate-btn[data-v-55de08c6]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:64px auto;padding:25px 50px}@media (max-width:767px){.awards-top-section__nominate-btn-wrapper .awards-top-section__nominate-btn[data-v-55de08c6]{padding:13px 50px}}", ""]);
// Exports
module.exports = exports;
